import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["href"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { key: 5 }
const _hoisted_10 = { key: 6 }

import { computed, ref } from "vue";
import { useStore } from "vuex";
import { IncomeStipulationTypeIds } from "@/config/constants";
import DOMPurify from "dompurify";
import NonIncomeResponsibleApplicant from "@/components/checklist/stipulation-texts/NonIncomeResponsibleApplicant.vue";
import EstablishMembership from "@/components/checklist/stipulation-texts/EstablishMembership.vue";
import {
  isStipulationStatus,
  isStipulationType,
  useStipulation,
} from "@/composables/stipulations/useStipulation";
import { MembershipStipulationTypeIds } from "@/config/constants";
import { Stipulation } from "@/models/opal";
import { StipulationStatusIds } from "@/config/constants";

interface Props {
  subitem: Stipulation;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StipulationText',
  props: {
    subitem: {}
  },
  setup(__props: any) {

const store = useStore();

const props = __props;

const htmlRef = ref<HTMLElement | HTMLAnchorElement | HTMLDivElement | null>();

const stipulation = computed<Stipulation>(() => props.subitem);

const {
  isCreditBureauAction,
  tollFreeNumber,
  hrefTFN,
  emailAddress,
  stipulationText,
  showSampleDocument,
  sampleDocumentCdnUrl,
  hideStipTextStips,
  htmlStipTextStipsWithMergeFields,
  htmlStipTextStips,
  lenderData,
  configuration,
} = useStipulation(stipulation);

function handleClick() {
  //#TODO
  console.log("handleClickHere");

  // Get latest stips after
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.subitem?.isExpectedDocument)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_unref(isStipulationStatus)(__props.subitem, _unref(StipulationStatusIds).OPEN) && _unref(showSampleDocument))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("a", {
                  target: "_blank",
                  href: _unref(sampleDocumentCdnUrl)
                }, "See sample here", 8, _hoisted_2)
              ]))
            : _createCommentVNode("", true),
          (_unref(isStipulationStatus)(__props.subitem, _unref(StipulationStatusIds).OPEN))
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.subitem.stipulationText), 1))
            : _createCommentVNode("", true),
          (_unref(isStipulationStatus)(__props.subitem, _unref(StipulationStatusIds).PENDING))
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Your submission has been received and is awaiting review. This status will update once the review is complete. "))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_unref(hideStipTextStips).includes(__props.subitem.stipulationTypeId))
            ? (_openBlock(), _createElementBlock("p", _hoisted_5))
            : (_unref(isCreditBureauAction) && _unref(stipulationText))
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_unref(stipulationText).split(`${_unref(tollFreeNumber)}`)?.[0]) + " ", 1),
                  _createElementVNode("a", {
                    href: `tel:${_unref(hrefTFN)}`
                  }, " " + _toDisplayString(_unref(tollFreeNumber)) + " ", 9, _hoisted_7),
                  _createTextVNode(_toDisplayString(_unref(stipulationText).split(`${_unref(tollFreeNumber)}`)?.[1]), 1)
                ]))
              : (
          _unref(isStipulationType)(__props.subitem, _unref(MembershipStipulationTypeIds).EstablishMembership) &&
          _unref(isStipulationStatus)(__props.subitem, _unref(StipulationStatusIds).OPEN)
        )
                ? (_openBlock(), _createBlock(EstablishMembership, {
                    key: 2,
                    text: __props.subitem.stipulationText,
                    lenderName: _unref(lenderData)?.name
                  }, null, 8, ["text", "lenderName"]))
                : (
          _unref(isStipulationType)(__props.subitem, _unref(IncomeStipulationTypeIds).NonIncomeResponsibleApplicant)
        )
                  ? (_openBlock(), _createBlock(NonIncomeResponsibleApplicant, {
                      key: 3,
                      stip: __props.subitem,
                      onClick: handleClick
                    }, null, 8, ["stip"]))
                  : (_unref(htmlStipTextStips).includes(__props.subitem?.stipulationTypeId))
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 4,
                        ref_key: "htmlRef",
                        ref: htmlRef,
                        innerHTML: _unref(DOMPurify).sanitize(__props.subitem.stipulationText)
                      }, null, 8, _hoisted_8))
                    : (_unref(isStipulationStatus)(__props.subitem, _unref(StipulationStatusIds).PENDING))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Verification Pending "))
                      : (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(__props.subitem.stipulationText), 1))
        ], 64))
  ]))
}
}

})